'use strict';

intellidealerAppEquipmentModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.equipment.equipmentForSale.equipmentForSaleDetails.engine', {
      url: '/engine',
      templateUrl: 'app/scripts/modules/equipment/views/engine.html'
    }
  );

  $stateProvider.state(
    'public.equipment.equipmentForSale.equipmentForSaleDetails.engine', {
      url: '/engine',
      templateUrl: 'app/scripts/modules/equipment/views/engine.html'
    }
  );
}]);
